export default __webpack_public_path__ + "3c99ec8b2c31ed8a57c66d18591a45e7.jpg";